import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GoogleCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const message = params.get("message");
    const error = params.get("error");
    const page = params.get("page") || localStorage.getItem("authPage") || "login";

    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("googleMessage", message || "Login successful");
      navigate(`/${page}`);
    } else if (error) {
      localStorage.setItem("googleError", error);
      navigate(`/${page}`);
    } else {
      navigate("/login");
    }

    // Clean up intent info
    localStorage.removeItem("authPage");
  }, [navigate]);

  return <p>Processing Google login...</p>;
};

export default GoogleCallback;
